import { useEnvironmentContext } from "@chakra-ui/react";
import { useCallback, useEffect } from "react";
/**
 * Used for hiding an element if there is a click outside the element.
 * Supports both regular DOM and Shadow DOM environments by using composedPath.
 *
 * @param ref - A ref to the element
 * @param handleVisibility - A set state function that will be called when clicking outside the ref. false will be passed in as the state value
 * @param refToFocusOnAfter - An optional ref to move focus to after the element is hidden
 */
var useDetectClickOutside = function (ref, handleVisibility, refToFocusOnAfter) {
    var environment = useEnvironmentContext();
    var handleClickOutside = useCallback(function (event) {
        if (!ref.current)
            return;
        // Use composedPath to get the full event path including shadow DOM elements
        var path = event.composedPath();
        // Check if the ref element is in the composed path
        if (!path.includes(ref.current)) {
            handleVisibility(false);
            if (refToFocusOnAfter === null || refToFocusOnAfter === void 0 ? void 0 : refToFocusOnAfter.current) {
                refToFocusOnAfter.current.focus();
            }
        }
    }, [ref, handleVisibility, refToFocusOnAfter]);
    useEffect(function () {
        var eventType = "pointerdown";
        var ownerDocument = environment.getDocument();
        ownerDocument.addEventListener(eventType, handleClickOutside, true);
        return function () {
            ownerDocument.removeEventListener(eventType, handleClickOutside, true);
        };
    }, [environment, handleClickOutside]);
};
export default useDetectClickOutside;
